module.exports = __webpack_public_path__ + "img/rc-active.36aa7b74.png";